import { isPatrolmanPlusSku, isPatrolmanSku } from "../configuration-sku-family.js";

/** Reset label stocked at Final QC (station 9) via manufacturing.station_stock. */
export const FINAL_QC_RESET_LABEL_SKU = "88-103";

export function isFinalQcResetLabelStationStockSku(skuRaw: string): boolean {
  return skuRaw.trim().toLowerCase() === FINAL_QC_RESET_LABEL_SKU.toLowerCase();
}

/** Map a finished device SKU to the reset label consumed when Final QC grades the unit. */
export function resolveFinalQcResetLabelSku(finishedSkuRaw: string): string | null {
  const finishedSku = finishedSkuRaw.trim();
  if (finishedSku === "") return null;
  if (isPatrolmanSku(finishedSku) || isPatrolmanPlusSku(finishedSku)) {
    return FINAL_QC_RESET_LABEL_SKU;
  }
  return null;
}
